export enum DeletionApprovalStatusType {
    Approved = 1,
    Denied = 2,
    Abandoned = 3,
    InProgress = 4,
    Error = 5
  }